import { initAccordion } from './components/accordion.js';
import { initBookTablePanel } from './components/book-table-panel.js';
import { initHeader } from './components/header.js';
import { initLoader } from './components/loader.js';
import { initMenuSlider } from './components/menu-slider.js';
import { initModal } from './components/modal.js';
import { initNav } from './components/nav.js';
import { initReveal } from './components/reveal.js';
import { initGallery } from './components/gallery.js';
import { initFeatureSlider } from './components/feature-slider.js';
import { initMediaSlider } from './components/media-slider.js';
import { initMapSlider } from './components/map-slider.js';
import { initTabs } from './components/tabs.js';
import { initTestimonials } from './components/testimonials.js';
// import { initSearch } from './components/search.js';
// import { initGformFieldFeedback } from './components/gform-field-feedback.js';
import { initLenis } from './utils/lenis-scroll.js';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initLenis();
  initLoader();
  initReveal();
  initAccordion();
  initMenuSlider();
  initModal();
  initNav();
  initBookTablePanel();
  initGallery();
  initFeatureSlider();
  initMediaSlider();
  initMapSlider();
  initTabs();
  initTestimonials();
  // initSearch();
});
